import React from 'react';
import { observer } from 'mobx-react';
import { Switch } from 'antd';
import { Catcher } from '../';
import { AppSystem } from '../../interfaces';
import { useAppSystem, useProfileFeatureFlags, useProfileIsRight } from '../../hooks';
import { setAppSystemBySwitch } from '../../middleware';
import Styles from './m_styles.less';

export const AppSwitch: React.FC = observer(() => {
    const featureFlags = useProfileFeatureFlags();
    const isLord = useProfileIsRight('LORD');
    const appSystem = useAppSystem();

    const _setChangeAppSystem = (value: boolean) => {
        if (value) {
            return setAppSystemBySwitch(AppSystem.BILLING);
        }

        setAppSystemBySwitch(AppSystem.OCS);
    };

    return isLord && featureFlags?.newChargingSystem ? (
        <Catcher>
            <div className={Styles.main}>
                <span className={appSystem === AppSystem.OCS ? Styles.active : Styles.default}>OCS</span>
                <Switch onChange={_setChangeAppSystem} checked={appSystem !== AppSystem.OCS} />
                <span className={appSystem === AppSystem.BILLING ? Styles.active : Styles.default}>Billing System</span>
            </div>
        </Catcher>
    ) : null;
});
